<template>
  <footer class="footer">
    <div class="footer-container">
      <div class="footer-content">
        <div class="footer-section">
          <h3>关于我们</h3>
          <p>Autozhuan是一个专业的自动化赚钱工具平台，致力于为用户提供高效、安全的自动化解决方案。</p>
        </div>
        <div class="footer-section">
          <h3>快速链接</h3>
          <ul>
            <li><router-link to="/">首页</router-link></li>
            <li><router-link to="/product-intro">产品介绍</router-link></li>
            <li><router-link to="/case-show">案例展示</router-link></li>
            <li><router-link to="/community">用户社区</router-link></li>
          </ul>
        </div>
        <div class="footer-section">
          <h3>联系我们</h3>
          <div class="social-links">
            <a href="mailto:1592666828@ctreas.com" class="social-link" title="发送邮件">
              <i class="iconfont icon-xinfengyoujian"></i>
            </a>
            <span>1592666828@ctreas.com</span>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <p>&copy; 2024 Autozhuan. 版权所有. <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">闽ICP备20003271号</a></p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>

<style scoped>
.footer {
  background-color: #332922;
  color: #F9F5F0;
  padding: 40px 0 20px;
  margin-top: auto;
}

.footer-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 30px;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
  margin-bottom: 30px;
}

.footer-section h3 {
  color: #E88849;
  margin-bottom: 15px;
  font-size: 18px;
}

.footer-section p {
  line-height: 1.6;
  margin-bottom: 10px;
}

.footer-section ul {
  list-style: none;
  padding: 0;
}

.footer-section ul li {
  margin-bottom: 8px;
}

.footer-section ul li a {
  color: #F9F5F0;
  text-decoration: none;
  transition: color 0.3s;
}

.footer-section ul li a:hover {
  color: #E88849;
}

.social-links {
  display: flex;
  align-items: center;
  gap: 15px;
}

.social-link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: #594535;
  border-radius: 50%;
  color: #F9F5F0;
  text-decoration: none;
  transition: all 0.3s;
}

.social-link:hover {
  background-color: #E88849;
  transform: translateY(-2px);
}

/* 邮箱联系方式样式 */
.contact-email {
  text-align: center;
  color: #F9F5F0;
  font-size: 14px;
  margin-top: 10px;
}

.contact-email span {
  transition: color 0.3s;
}

.contact-email:hover span {
  color: #E88849;
}

.footer-bottom {
  border-top: 1px solid #594535;
  padding-top: 20px;
  text-align: center;
}
.footer-bottom a {
  color: #fff;
  text-decoration: none;
}

@media (max-width: 768px) {
  .footer-content {
    grid-template-columns: 1fr;
    text-align: center;
  }
  
  .social-links {
    justify-content: center;
  }
}
</style>
